/**
 * @author lifei
 * 功能：公共常量维护（全局）
 */
import * as func from '@/func'
const enumToList = func.enumToList()
/**
 * 功能：http 业务状态码
 */
export const HTTP_BUS_STATUS = Object.freeze({
  '200': '请求成功',
  '400': '错误的请求',
  '401': '没有授权',
  '500': '网络服务异常', // 服务器内部错误
  '502': '错误的网关',
  '504': '网关超时', // 网关超时
})

// 查看/新建/编辑
export enum stateMachine {
  SEE = 'see', // 查看
  ADD = 'add', // 新增
  EDIT = 'edit', // 编辑
}

/**
 * 1-1、oss 访问类型
 */
export enum MapOSSAccessType {
  public = '0',
  private = '1',
}

/**
 * 功能：页签额外操作 map，右键菜单
 */
export enum MapTabOperate {
  关闭当前左侧 = 'left',
  关闭当前右侧 = 'right',
  关闭其他页 = 'other',
  关闭当前页 = 'self',
  刷新当前页 = 'refresh',
}

/**
 * 功能：页签额外操作 list，右键菜单
 */
export const ListTabOperate = Object.freeze<TCommon.CustomDictItem[]>(enumToList({ MapTabOperate }, /^[a-z]+$/))

/**
 * 功能：颜色映射 map
 */
export enum MapTheme {
  默认 = 'default',
  暗色 = 'dark',
}

/**
 * 功能：颜色映射 list
 */
export const ListTheme = Object.freeze(enumToList({ MapTheme }))

/**
 * 功能：主题色颜色配置, 暂时这么定义后面会使用 :root 方案
 */
export const Theme = {
  default: {
    colorPrimary: '#1677ff',
    colorInfo: '#1677ff',
  },
  dark: {
    colorPrimary: '#333', //品牌主色
    colorInfo: '#5f0aff', //信息色
  },
}

/**
 * 功能：标签 业务类型（0-会员；1-商品；2-用户）
 */
export enum TagBizType {
  VIP,
  GOODS,
  USER,
}

/**
 * 功能：标签 类型（0-人工标签；1-系统标签）
 */
export enum TagType {
  ARTIFICIAL,
  SYSTEM,
}

// 是否(01)选项, 0是  1否
export enum Whether {
  YES = 0,
  NO = 1,
}
export enum WhetherName {
  YES = '是',
  NO = '否',
}
export enum YetStatusEnum {
  已启用 = 0,
  已禁用,
}
export enum StatusEnum {
  启用 = 0,
  禁用,
}
export enum StatusColorEnum {
  'green' = 0,
  'red',
}
export enum yetStatusSecondEnum {
  已启用 = 1,
  已禁用 = 0,
}
export enum yetStatusSecondColorEnum {
  'red',
  'green',
}
// 日期描述枚举（year：年，month：月，week：周，day：天，hour：时，minute：分，second：秒）
export enum DateDescEnum {
  /**
   * 年
   */
  YEAR = 'year',
  /**
   * 月
   */
  MONTH = 'month',
  /**
   * 周
   */
  WEEK = 'week',
  /**
   * 天
   */
  DAY = 'day',
  /**
   * 时
   */
  HOUR = 'hour',
  /**
   * 分
   */
  MINUTE = 'minute',
  /**
   * 秒
   */
  SECOND = 'second',
}
export enum DateDescEnumName {
  YEAR = '年',
  MONTH = '月',
  WEEK = '周',
  DAY = '天',
  HOUR = '时',
  MINUTE = '分',
  SECOND = '秒',
}

// 弹框尺寸（big: 大，centre：中，small：小）
export enum ModalSizeEnum {
  /**
   * 大
   */
  BIG = 'big',
  /**
   * 中
   */
  CENTRE = 'centre',
  /**
   * 小
   */
  SMALL = 'small',
}
export enum ModalSizeEnumName {
  BIG = '大',
  CENTRE = '中',
  SMALL = '小',
}

// TS类型枚举（string: 字符串， number: 数字， date: 日期， boolean: 布尔值， object: 对象， array: 数组， function: 函数， unknown: 未知， undefined: 未定义）
export enum TsTypeOfEnum {
  /**
   * 字符串
   */
  STRING = 'string',
  /**
   * 数字
   */
  NUMBER = 'number',
  /**
   * 日期
   */
  DATE = 'date',
  /**
   * 布尔值
   */
  BOOLEAN = 'boolean',
  /**
   * 对象
   */
  OBJECT = 'object',
  /**
   * 数组
   */
  ARRAY = 'array',
  /**
   * 函数
   */
  FUNCTION = 'function',
  /**
   * 未知
   */
  UNKNOWN = 'unknown',
  /**
   * 未定义
   */
  UNDEFINED = 'undefined',
}
export enum TsTypeOfEnumName {
  STRING = '字符串',
  NUMBER = '数字',
  DATE = '日期',
  BOOLEAN = '布尔值',
  OBJECT = '对象',
  ARRAY = '数组',
  FUNCTION = '函数',
  UNKNOWN = '未知',
  UNDEFINED = '未定义',
}

//区分表格行操作类型 check:选中; edit: 编辑; del: 删除; sub: 提交; add: 添加; view: 查看; print: 打印; more: 更多;custom: 自定义; setting: 设置;close:关闭；understand：了结; down:下推; import:导入; export:导出; copy:复制
export enum TableLinkActionEnum {
  /**
   * 选中
   */
  check = 'check',
  /**
   * 编辑
   */
  edit = 'edit',
  /**
   * 删除
   */
  del = 'del',
  /**
   * 提交
   */
  sub = 'sub',
  /**
   * 添加
   */
  add = 'add',
  /**
   * 查看
   */
  view = 'view',
  /**
   * 打印
   */
  print = 'print',
  /**
   * 更多
   */
  more = 'more',
  /**
   * 自定义
   */
  custom = 'custom',
  /**
   * 设置
   */
  setting = 'setting',
  /**
   * 关闭
   */
  close = 'close',
  /**
   * 了结
   */
  understand = 'understand',
  /**
   * 下推
   */
  down = 'down',
  /**
   * 导入
   */
  import = 'import',
  /**
   * 导出
   */
  export = 'export',
  /**
   * 复制
   */
  copy = 'copy',
}
export enum TableLinkActionEnumName {
  check = '选中',
  edit = '编辑',
  del = '删除',
  sub = '提交',
  add = '添加',
  view = '查看',
  print = '打印',
  more = '更多',
  custom = '自定义',
  setting = '设置',
  close = '关闭',
  understand = '了结',
  down = '下推',
  import = '导入',
  export = '导出',
  copy = '复制',
}